// @ts-nocheck
import React, {useCallback, useState} from 'react';
import markerIcon from '@assets/images/icons/icon-map.png';
import {getParams} from "@src/helpers";
import {Redirect} from "react-router-dom";
import {GoogleMap, InfoBox, Marker, useJsApiLoader} from '@react-google-maps/api';
import _ from "lodash-es";
import ProcessesMarkers from "@components/module-components/POSMap/ProcessesMarkers";
import {ENV} from "@environments/environment";

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY, URL_WEBAPP} = ENV

const mapLibraries = ['geometry']

const StepMap = ({marker, name, processes = []}: any) => {

    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GG_KEY,
        libraries: mapLibraries,
    })

    const [map, setMap] = useState(null)
    const [locRedirect, setLocRedirect] = useState('');

    const distanceBound = parseFloat("00.0080000");
    const newLat = parseFloat(marker.lat);
    const newDisBound = newLat - distanceBound;
    const newMapCenterDefault = {
        lat: newDisBound,
        lng: parseFloat(marker.lng)
    }

    const newMarker = {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
    };

    const {order = '', brand = ''} = getParams();

    const onLoad = () => {

    }

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])


    return locRedirect ?
        <Redirect push to={`/step-detail?order=${order}&process=${locRedirect}&brand=${brand}`}/> : (
            isLoaded
                ? <GoogleMap
                    mapContainerStyle={{
                        width: '100%',
                        height: '770px'
                    }}
                    zoom={16}
                    center={newMarker}
                    mapTypeId={window.google.maps.MapTypeId.ROADMAP}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                >
                    <Marker icon={markerIcon} position={newMarker} cursor="default">
                        {name && <InfoBox options={{boxClass: 'map-manufacturer'}}>
                            <div>{name}</div>
                        </InfoBox>}
                    </Marker>

                    {
                        _.map(processes, (g: any) =>
                            <ProcessesMarkers key={_.uniqueId('connected_orders_')} dataMap={g}
                                              onClickProcess={(process_id) => setLocRedirect(process_id)}/>)
                    }

                </GoogleMap>
                : <></>
        );
}


export default StepMap;
